<template>
  <v-app
    id="app"
  >
    <v-content>
      <v-navigation-drawer
        v-model="sideNav"
        app
        flat
        dark
        temporary
      >
        <v-list>
          <v-list-tile
            v-for="item in menuItems" :key="item.title"
            router
            :to="item.link">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-navigation-drawer>
      <v-toolbar
        app
        flat
        dark
        color='accent'
      >
        <v-toolbar-side-icon
          @click.native.stop="sideNav = !sideNav"
          class="hidden-sm-and-up"></v-toolbar-side-icon>
        <router-link to="/" tag="span" style="cursor: pointer;">
          <v-toolbar-title>
            <img
              src="@/assets/images/SunPeak_On_Dark.png"
              alt="SunPeak"
              id="logo-img"
              class=""
            >
          </v-toolbar-title>
        </router-link>
        <v-spacer class="hidden-sm-and-up"></v-spacer>
        <v-spacer></v-spacer>
        <v-toolbar-items class="hidden-xs-only">
          <v-btn
            flat
            v-for="item in menuItems"
            :key="item.title"
            router
            :to="item.link"
          ><v-icon left>{{ item.icon }}</v-icon>{{ item.title }}</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>
export default {
  data () {
    return {
      sideNav: false
    }
  },
  computed: {
    menuItems () {
      let menuItems = [
        {title: 'Sign In', link: '/signin', icon: 'person'},
        {title: 'Sign Up', link: '/signup', icon: 'person'}
      ]
      if (this.userIsAuthenticated) {
        menuItems = [
          {title: 'Tools', link: '/tools', icon: 'build'},
          {title: 'Training', link: '/training', icon: 'import_contacts'},
          {title: 'Profile', link: '/profile', icon: 'person'}
        ]
      }
      return menuItems
    },
    userIsAuthenticated () {
      return this.$store.getters['user/isAuthenticated']
    }
  },
  name: 'App'
}
</script>

<style>
  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 0px;
  }
  #logo-img {
    max-height: 40px;
    object-fit: contain;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue